<script>
</script>
<template>
    <div>
        <p>Rakuten Advertising Network Verification - Diginink SID - 4028758</p>
    </div>
</template>